/**
 * @param time 传入的时间字符串"2019-09-19 17:55:06"
 * @param type 要返回的时间字符串的格式类型
 * @param noformat 是否格式化时间为标准时间
 * @returns {string}
 */
import moment from 'moment';
import areaJson from '../assets/js/china_address_v4.js';
// 调用样例：{{(val,key) | commonFilterName}}
// commonFilterName   获取字典中值对应的名称
const commonFilterName = (val, key) => {
  if (!val || !key) {
    return '-';
  }
  const codeListJson = localStorage.getItem('codeList');
  if (!codeListJson) {
    return '-';
  }
  const codeList = JSON.parse(codeListJson);
  const dictType = codeList.find(item => item.dictTypeName === key);
  if (!dictType || !Array.isArray(dictType.dictList)) {
    return '-';
  }
  const dictItem = dictType.dictList.find(item => {
    return String(item.value) === String(val);
  });
  return dictItem?.text || '-';

};
// commonFilterNameList   获取字典中值对应的名称,数组类
const commonFilterNameList = (val, key) => {
  let arr = [];
  if (!val || undefined || !localStorage.codeList || val.length == 0) {
    return '-';
  } else {
    let codeList = JSON.parse(localStorage.codeList);
    let list = codeList.filter((item) => item.dictTypeName == key);
    if (list && list.length > 0) {
      let dictList = list[0].dictList;
      dictList.forEach((i) => {
        val.forEach((j) => {
          if (i.value == j) {
            arr.push(i.text);
            // name = i.text;
          }
        });
      });
      return arr.join(',')
    }
  }
};
const errorInfo = (val) => {
  if (val == '' || val == null) {
    return '无错误信息';
  } else {
    let a = val.split('/r/n');
    let errorInfoList = [];
    a.forEach(function (i) {
      if (i != '') {
        errorInfoList.push(i);
      }
    });
    return errorInfoList.toString();
  }
};
// 调用样例：{{mydate | getDate}}
// 省
const province = (val, type) => {
  if (val == '' || val == null) {
    return type == 1 ? '' : '-';
  } else {
    let pr = type == 1 ? '' : '-';
    areaJson.forEach(function (j) {
      if (j.value == val) {
        pr = j.label;
      }
    });
    return pr;
    // return moment(val).format('YYYY-MM-DD');
  }
};

// 市
const city = (val, type) => {
  if (val == '' || val == null) {
    return type == 1 ? '' : '-';
  } else {
    let ci = type == 1 ? '' : '-';
    areaJson.forEach(function (i) {
      if (i.children != null && i.children != '') {
        i.children.forEach(function (j) {
          if (j.value == val) {
            ci = j.label;
          }
        });
      }
    });
    return ci;
  }
};

// 区(县)
const district = (val, type) => {
  if (val == '' || val == null) {
    return type == 1 ? '' : '-';
  } else {
    let di = type == 1 ? '' : '-';
    areaJson.forEach(function (i) {
      if (i.children != null && i.children != '') {
        i.children.forEach(function (j) {
          if (j.children != null && j.children != '') {
            j.children.forEach(function (n) {
              if (n.value == val) {
                di = n.label;
              }
            });
          }
        });
      }
    });
    return di;
  }
};

// 调用样例：{{mydate | getMonth}}
// getDateStartEnd   年月日   YY-MM
const getMonth = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return moment(val).format('YYYY-MM');
  }
};

// 调用样例：{{mydate | getDate}}
// getDateStartEnd   年月日   YY-MM-DD
const getDate = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return moment(val).format('YYYY-MM-DD');
  }
};

// 调用样例：{{mydate | getDate}}
// getDateStartEnd   年月日   YY-MM-DD
const getTimeDate = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return moment(val).format('YYYY-MM-DD HH:mm:ss');
  }
};

// 调用样例：{{mydate | getDate}}
// getDateStartEnd   年月日   YY-MM-DD
const getTime = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return moment(val).format('YYYY-MM-DD HH:mm');
  }
};

// 调用样例：{{mydate | getDate}}
// getDateStartEnd   精确到毫秒
const getTimeS = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return moment(val).format('YYYY-MM-DD HH:mm:ss.SSSSSS');
  }
};

// 分钟数换算
const minTime = (val) => {
  let minTime = '';
  let h = Math.floor(val / 60);
  val -= h * 60;
  if (val == 0) {
    minTime = h ? h + '小时' : '';
  } else {
    if (val < 10) {
      val = '0' + val;
    }
    minTime = (h ? h + '小时' : '') + (val ? val + '分钟' : '');
  }
  return minTime;
};

// 调用样例：{{mydate | getDate}}
// getDateStartEnd   年月日   YY-MM-DD
const getVisible = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return val == 'Y' ? '是' : '否';
  }
};

// 调用样例：{{mydate | getDate}}
// payState 发放状态
const payState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return val == 'S' ? '是' : '否';
  }
};

// 调用样例：{{mydate | getDate}}
// getDateStartEnd   年月日   YY-MM-DD
const getMenuType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'M') {
      return (val = '目录');
    } else if (val == 'C') {
      return (val = '菜单');
    } else if (val == 'P') {
      return (val = '页面');
    } else {
      return (val = '按钮');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// getDateStartEnd   年月日   YY-MM-DD
const getBizState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return val == 'Y' ? '有效' : '停用';
  }
};

const getstaffType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return val == '1' ? '组织内成员' : '备案成员';
  }
};

const roleNames = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return val.toString();
  }
};

// 调用样例：{{mydate | getDate}}
// insuranceStatus   社保状态
const insuranceStatus = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 1) {
      return (val = '待参保');
    } else if (val == 2) {
      return (val = '已参保');
    } else if (val == 3) {
      return (val = '已删除');
    } else if (val == 4) {
      return (val = '参保终止');
    } else if (val == 5) {
      return (val = '待补缴');
    } else if (val == 6) {
      return (val = '补缴成功');
    } else {
      return (val = '其他');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// modelType   商品分类
const modelType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 1) {
      return (val = '短尾');
    } else if (val == 2) {
      return (val = '中尾');
    } else {
      return (val = '长尾');
    }
  }
};

/** 
  数字小数位强制位数要求，即使为0，也会为0.0000 
  x：参数，数值，如果为空，按0处理
  digit：小数后几位，int
  用法：{{invoice.invoiceamount | numDigit}}
*/
const numDigit = (val) => {
  if (val == '' || val == null) {
    return '0.00';
  }
  if (val == '-' ) {
    return '-';
  }
  val = val.toString().replace(/\$|\,/g, '');
  if (isNaN(val)) {
    val = '0';
  }
  let sign = val == (val = Math.abs(val));
  val = Math.floor(val * 100 + 0.50000000001);
  let cents = val % 100;
  val = Math.floor(val / 100).toString();
  if (cents < 10) {
    cents = '0' + cents;
  }
  for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
    val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
  }

  return (sign ? '' : '-') + val + '.' + cents;
};

/** 
  数字格式化 ，格式为888,888,888.232
  number：参数，数值
  如果为空，返回0
  用法：{{invoice.invoiceamount | numFmt}}
*/
const numFmt = (val) => {
  if (val == '' || val == null) {
    return 0;
  }
  if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(val)) {
    return val;
  }
  var a = RegExp.$1,
    b = RegExp.$2,
    c = RegExp.$3;
  var re = new RegExp('(\\d)(\\d{3})(,|$)');
  while (re.test(b)) b = b.replace(re, '$1,$2$3');
  return a + '' + b + '' + c;
};

// 调用样例：{{mydate | getDate}}
// approvalState   绩效表审批状态
const approvalState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'N') {
      return (val = '-');
    } else if (val == 'A') {
      return (val = '待审批');
    } else if (val == 'R') {
      return (val = '已驳回');
    } else {
      return (val = '已审批');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// approvalState   合同性质
const natureType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'W') {
      return (val = '待签约');
    } else if (val == 'Y') {
      return (val = '履约中');
    } else if (val == 'E') {
      return (val = '已到期');
    } else {
      return (val = '已解约');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// approvalState   合同性质
const enterpriseCate = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '9901') {
      return (val = 'CSO');
    } else if (val == '0101') {
      return (val = '医药生产');
    } else if (val == '010201') {
      return (val = '医药流通');
    } else if (val == '9904') {
      return (val = '用工平台');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// approvalState   绩效提报表审批状态
const approvalStateTwo = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'N') {
      return (val = '待提报');
    } else if (val == 'A') {
      return (val = '待提报');
    } else if (val == 'R') {
      return (val = '待提报');
    } else {
      return (val = '已提报');
    }
  }
};
// 调用样例：{{mydate | getDate}}
// performancePayState   绩效发放
const performancePayState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'W') {
      return (val = '待发放');
    } else if (val == 'Y') {
      return (val = '已发放');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// 大区 region
const region = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'NE') {
      return (val = '东北区');
    } else if (val == 'NC') {
      return (val = '华北区');
    } else if (val == 'SC') {
      return (val = '华南区');
    } else if (val == 'NW') {
      return (val = '西北区');
    } else if (val == 'SW') {
      return (val = '西南区');
    } else if (val == 'CC') {
      return (val = '华中区');
    } else if (val == 'EC') {
      return (val = '华东区');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// 签约状态 contractState
const contractState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'W') {
      return (val = '待签约');
    } else if (val == 'Y') {
      return (val = '履约中');
    } else if (val == 'E') {
      return (val = '已到期');
    } else if (val == 'S') {
      return (val = '已解约');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// approvalState   合同性质
const importState = (val) => {
  if (val == '' || val == null) {
    return '';
  } else {
    if (val == 'P') {
      return (val = '导入中');
    } else if (val == 'Y') {
      return (val = '导入成功');
    } else if (val == 'E') {
      return (val = '导入失败');
    }
  }
};

// 调用样例：{{mydate | approvalState}}
// 审批状态 approvalState
const approvalStateCost = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'N' || val == 'A') {
      return (val = '审批中');
    } else if (val == 'Y') {
      return (val = '已通过');
    } else if (val == 'R') {
      return (val = '驳回');
    } else if (val == 'C') {
      return (val = '已撤销');
    }
  }
};

// 调用样例：{{mydate | approvalState}}
// 审批状态 approvalState
const valueType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '数字(tinyint)');
    } else if (val == '2') {
      return (val = '数字(int)');
    } else if (val == '3') {
      return (val = '使用option下拉框(单选)');
    } else if (val == '4') {
      return (val = '使用option下拉框(多选)');
    } else if (val == '5') {
      return (val = '使用radio选项卡');
    } else if (val == '6') {
      return (val = '时间区间');
    } else if (val == '7') {
      return (val = 'checkbox多选框');
    } else if (val == '8') {
      return (val = '文本框');
    }
  }
};
//绝对值
const absoluteValue = (value) => {
  if (!value) return 0;
  if (value) {
    let absoluteValue = Math.abs(value);
    return absoluteValue;
  }
};
const smallToBig = (val) => {
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'); //汉字的数字
  var cnIntRadice = new Array('', '拾', '佰', '仟'); //基本单位
  var cnIntUnits = new Array('', '万', '亿', '兆'); //对应整数部分扩展单位
  var cnDecUnits = new Array('角', '分', '毫', '厘'); //对应小数部分单位
  var cnInteger = '整'; //整数金额时后面跟的字符
  var cnIntLast = '元'; //整数完以后的单位
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  var integerNum; //金额整数部分
  var decimalNum; //金额小数部分
  //输出的中文金额字符串
  var chineseStr = '';
  var parts; //分离金额后用的数组，预定义
  if (val == '' || val == null) {
    return '零元';
  }

  val = parseFloat(val);
  if (val >= maxNum) {
    //超出最大处理数字
    return '超出最大处理数字';
  }
  if (val == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }

  //四舍五入保留两位小数,转换为字符串
  val = Math.round(val * 100).toString();
  integerNum = val.substr(0, val.length - 2);
  decimalNum = val.substr(val.length - 2);

  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '' || /^0*$/.test(decimalNum)) {
    chineseStr += cnInteger;
  }
  return chineseStr;
};
// 调用样例：{{mydate | flowType}}
// 流程类型 flowType
const flowType = (val) => {
  if (val == '' || val == null) {
    return '';
  } else {
    if (val == '00001') {
      return (val = '会议任务申请');
    } else if (val == '00002') {
      return (val = '线上会议执行2');
    } else if (val == '00003') {
      return (val = '会议任务总结');
    } else if (val == '00004') {
      return (val = '潜在客户信息申请4');
    }
  }
};

const summaryResultValueType = (val) => {
  if (val == '' || val == null) {
    return '';
  } else {
    if (val == '01') {
      return (val = '万元');
    } else if (val == '02') {
      return (val = '%');
    } else if (val == '03') {
      return (val = '');
    }
  }
};

// 调用样例：{{mydate | fileUrl}}
// fileUrl   文件路径
const fileUrl = (val) => {
  if (val == '' || val == null) {
    this.$message.error('下载失败！');
    return '';
  } else {
    return JSON.parse(val)[0].path;
  }
};
// 调用样例：{{mydate | fileName}}
// fileUrl   文件路径
const fileName = (val) => {
  if (val == '' || val == null) {
    this.$message.error('下载失败！');
    return '';
  } else {
    let name = JSON.parse(val)[0].fileName;
    console.log('1111111', name);
    return name;
  }
};
const filterImgUrl = (val) => {
  //var imgdata = JSON.parse(val);
  if (val != null && val != 'null' && val && val != '[]' && val != '[null,null,null,null]') {
    val = JSON.parse(val);
    return val[0].path;
  } else {
    return require('../assets/images/none.jpg');
  }
};

// 调用样例：{{mydate | orgGradeType}}
// 机构等级 orgGradeType
const orgGradeType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '甲等');
    } else if (val == '2') {
      return (val = '乙等');
    } else if (val == '3') {
      return (val = '丙等');
    }
  }
};

// 调用样例：{{mydate | orgRankType}}
// 机构级次 orgRankType
const orgRankType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '一级');
    } else if (val == '2') {
      return (val = '二级');
    } else if (val == '3') {
      return (val = '三级');
    }
  }
};

// 调用样例：{{mydate | orgType}}
//  orgType机构类别
const orgType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '医院');
    } else if (val == '2') {
      return (val = '诊所');
    } else if (val == '3') {
      return (val = '卫生院');
    } else if (val == '4') {
      return (val = '社区卫生中心');
    }
  }
};

//会议类型
const meetingType = (val) => {
  if (!val) {
    return '-';
  }
  let str = '';
  switch (val) {
    case '1':
      str = '小型（单讲者会议 + 会议50人以内）';
      break;
    case '2':
      str = '中型（单讲者会议 + 会议100人以内）';
      break;
    case '3':
      str = '大型（多讲者会议 + 会议100人以上）';
      break;
  }
  return str;
};

//会议安全级别
const safeLevel = (val) => {
  if (!val) {
    return '-';
  }
  let str = '';
  switch (val) {
    case '1':
      str = '低（无限制）';
      break;
    case '2':
      str = '中（参会人需输入密码、短信验证）';
      break;
    case '3':
      str = '高（参会人需输入密码、短信验证、无法下载会议）';
      break;
  }
};

// 调用样例：{{mydate | getDate}}
// getDateStartEnd   年月日   YY-MM-DD
const getDateSFM = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    return moment(val).format('YYYY-MM-DD HH:mm:ss');
  }
};
//会议类型
const customerType = (val) => {
  if (!val) {
    return '-';
  }
  let str = '';
  switch (val) {
    case '1':
      str = '客户';
      break;
    case '2':
      str = '商业公司';
      break;
    case '3':
      str = '医生';
      break;
    case '4':
      str = '患者';
      break;
    case '5':
      str = '医院';
      break;
    case '6':
      str = '潜在客户';
      break;
    case '7':
      str = '潜在商业公司';
      break;
  }
  return str;
};
//支持负数
const upDigit = (val) => {
  var fraction = ['角', '分'];
  var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  var unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ];
  // 兼容数字字符串及千分位逗号，非法值按 0 处理
  val = parseFloat(String(val).replace(/[,，\s]/g, ''));
  if (isNaN(val)) {
    val = 0;
  }
  var head = val < 0 ? '负' : '';
  // 先一次乘法四舍五入到分再拆角/分：原 Math.floor(val*10*10^i) 两步乘法有浮点累积误差，会丢分或错分
  var cents = Math.round(Math.abs(val) * 100);
  var s = '';
  for (var i = 0; i < fraction.length; i++) {
    s += (digit[i === 0 ? Math.floor(cents / 10) % 10 : cents % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  val = Math.floor(cents / 100);
  for (var i = 0; i < unit[0].length && val > 0; i++) {
    var p = '';
    for (var j = 0; j < unit[1].length && val > 0; j++) {
      p = digit[val % 10] + unit[1][j] + p;
      val = Math.floor(val / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  );
};
//会议类型
const notifyPeriod = (val) => {
  if (!val) {
    return '-';
  }
  let str = '';
  switch (val) {
    case 'Y':
      str = '年';
      break;
    case 'M':
      str = '月';
      break;
    case 'W':
      str = '周';
      break;
    case 'D':
      str = '日';
      break;
  }
  return str;
};
// 调用样例：{{mydate | meetingBodyType}}
//  会议主体类型
const meetingBodyType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '医院');
    } else if (val == '2') {
      return (val = '商业公司');
    } else {
      return (val = '其他');
    }
  }
};

// 调用样例：{{orgRank | orgRank}}
//  医院次级
const orgRank = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '一级');
    } else if (val == '2') {
      return (val = '二级');
    } else {
      return (val = '三级');
    }
  }
};

// 调用样例：{{orgRank | orgRank}}
//  医院等级
const orgGrade = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '甲等');
    } else if (val == '2') {
      return (val = '乙等');
    } else if (val == '3') {
      return (val = '丙等');
    } else {
      return (val = '未评');
    }
  }
};

// 调用样例：{{orgRank | orgRank}}
//  维护状态
const maintainState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '0') {
      return (val = '未处理');
    } else if (val == '1') {
      return (val = '已维护');
    } else if (val == '2') {
      return (val = '无需处理');
    }
  }
};
// 调用样例：{{mydate | getDate}}
// getRateType   费率方式
const getRateType = (val) => {
  if (val == '' || val == null) {
    return (val = '');
  } else {
    if (val == '1') {
      return (val = '缺省费率');
    } else if (val == '2') {
      return (val = '自定义费率');
    } else if (val == '3') {
      return (val = '不计费');
    } else if (val == '4') {
      return (val = '按商品计费');
    }
  }
};

// 调用样例：{{mydate | getDate}}
// chargeState   收费状态
const getChargeState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'Y') {
      return (val = '正常');
    } else if (val == 'S') {
      return (val = '停止收费');
    } else if (val == 'N') {
      return (val = '不收费');
    }
  }
};
// getSigningType   签约转态
const getSigningType = (val) => {
  if (val == '' || val == null) {
    return (val = '');
  } else {
    if (val == 'N') {
      return (val = '未签');
    } else if (val == 'Y') {
      return (val = '已签');
    } else if (val == 'W') {
      return (val = '无需签');
    }
  }
};
// 调用样例：{{mydate | getDate}}
// InvoiceType   发票类型
const getInvoiceType = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '增值税普通发票');
    } else {
      return (val = '增值税专用发票');
    }
  }
};

// invoiceOptions   发票类型
const getInvoiceOptions = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '增值税专用发票');
    } else {
      return (val = '增值税普通发票');
    }
  }
};

const getInvoiceCategory =val => {
  if (val == '' || val == null) {
    return '-';
  } else {
    let keyValueMap = {
      '1':'信息技术服务*信息技术服务费',
      '2':'信息技术服务*信息系统服务',
      '3':'信息技术服务*软件维护服务',
      '4':'信息技术服务*技术咨询服务费',
      '5':'信息技术服务*物流管理信息系统 (WMS)',
      '6':'现代服务*市场推广服务费'
    }
    return keyValueMap[val] ? keyValueMap[val] : '-'
  }
}
const getInvoiceCategoryList =val => {
  if (val == '' ||!val|| val == null||val.length<1) {
    return '-';
  } else {
    let keyValueMap = {
      '1':'信息技术服务*信息技术服务费',
      '2':'信息技术服务*信息系统服务',
      '3':'信息技术服务*软件维护服务',
      '4':'信息技术服务*技术咨询服务费',
      '5':'信息技术服务*物流管理信息系统 (WMS)',
      '6':'现代服务*市场推广服务费'
    }
    // 用于存放找到的对应值
    let result = [];
    let list = val.split(',')
    list.forEach(item => {
        if (keyValueMap[item]) {
          result.push(keyValueMap[item]);
        }
    });
    return result.join(',');
  }
}
// 调用样例：{{mydate | getDate}}
// invoiceState   开票状态
const getInvoiceState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == '1') {
      return (val = '全额已开');
    } else if (val == '2') {
      return (val = '部分已开');
    } else if (val == '3') {
      return (val = '未开票');
    }
  }
};
// 调用样例：{{mydate | getDate}}
// supplierRate   开票状态
const getSupplierRate = (val) => {
  if (val == '' || val == null) {
    return 0.0;
  } else {
    return val * 1000;
  }
};
// 调用样例：{{mydate | getDate}}
// isInvoiceFirst  是否先开票
const getIsInvoiceFirst = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'Y') {
      return (val = '是');
    } else {
      return (val = '否');
    }
  }
};
// 调用样例：{{mydate | getDate}}
// getPaymentState  付款状态
const getPaymentState = (val) => {
  if (val == '' || val == null) {
    return '-';
  } else {
    if (val == 'Y') {
      return (val = '已付清');
    } else if (val == 'P') {
      return (val = '未付清');
    } else if (val == 'N') {
      return (val = '未付');
    }
  }
};
// 调用样例：{{orgRank | orgRank}}
//  建档日志状态
const operateType = (val) => {
  if (val == '' || val == null) {
    return '-';
  }
  const operateTypeMap = {
    1: '新增资料',
    2: '变更基础资料',
    4: '导入资料',
    5: '指派人员',
    6: '变更等级',
    7: '数据清洗导入',
  }
  return operateTypeMap[val] || '-'
    if (val == 1) {
      return (val = '新增资料');
    } else if (val == 2) {
      return (val = '变更基础资料');
    } else if (val == 4) {
      return (val = '导入资料');
    } else if (val == 5) {
      return (val = '指派人员');
    } else if (val == 6) {
      return (val = '变更等级');
    }
};
//导入状态
const importStateNew = (val) => {
  if (!val && val !== 0) {
    return '-';
  }
  switch (val) {
    case 0:
      return '导入成功';
      break;
    case 1:
      return '导入中';
      break;
    case -1:
      return '导入异常';
      break;
  }
};
//导入状态
const tenantAccountState = (val) => {
  if (!val) {
    return '-';
  }
  switch (val) {
    case 1:
      return '待提交';
      break;
    case 2:
      return '已通过';
      break;
    case 3:
      return '已驳回';
      break;
  }
};
//审批流中审批状态
const approveState = (val) => {
  if (!val) {
    return '-';
  }
  switch (val) {
    case 'Y':
      return '已通过';
      break;
    case 'R':
      return '已驳回';
      break;
    case 'A':
      return '审批中';
      break;
    case 'N':
      return '草稿中';
      break;
    case 'C':
      return '已撤销';
    case 'D':
      return '已废弃';
      break;
  }
};
//合同申请 季度
const quarterType = (val) => {
  if (!val) {
    return '-';
  }
  switch (val) {
    case '1':
      return '第一季度';
      break;
    case '2':
      return '第二季度';
      break;
    case '3':
      return '第三季度';
      break;
    case '4':
      return '第四季度';
      break;
  }
};
//合同申请 年度
const yearType = (val) => {
  if (!val) {
    return '-';
  }
  switch (val) {
    case '1':
      return '第一年';
      break;
    case '2':
      return '第二年';
      break;
    case '3':
      return '第三年';
      break;
    case '4':
      return '第四年';
      break;
    case '5':
      return '第五年';
      break;
  }
};
//市场推广计划 下发状态状态
const downState = (val) => {
  if (!val) {
    return '-';
  }
  switch (val) {
    case 'Y':
      return '已下发';
      break;
    case 'N':
      return '未下发';
      break;
    case 'P':
      return '部分下发';
      break;
  }
};

//发票信息管理 数据来源状态
const sourceTypeFilter = val => {
  if (!val) {
    return "-";
  }
  switch (val) {
    case 1:
      return "功能入口";
    case 2:
      return "流程入口";
  }
};

// 账户类型转换
const accountTypeFilter = val => {
  if (!val) {
    return "-";
  }
  switch (val) {
    case '1':
      return "基本户";
    case '2':
      return "一般户";
    case '3':
      return "开票户";
    case '4':
      return "打款户";
  }
};

// 账户类型转换
const idType = val => {
  if (!val) {
    return "-";
  }
  switch (val) {
    case '1':
      return "身份证";
    case '2':
      return "护照";
    case '3':
      return "其它";
  }
};

const contractContentTypeFilter = val=> {
  if (!val) {
    return "-";
  }
  switch (val) {
    case '1':
      return "收入";
    case '2':
      return "支出";
  }
}
//    清洗结果
const cleaningResult = val => {
	if(val=='' || val ==null){
	   return '-';
   }else{  
	   if(val == '1'){ 
		   return val = '匹配成功'
	   }else if(val == '2'){ 
		   return val = '匹配失败'
	   }else if(val == '3'){ 
		   return val = '修订'
	   }
   }
};
//    匹配结果
const matchingResult = val => {
	if(val=='' || val ==null){
	   return '-';
   }else{  
	   if(val == 'Y'){ 
		   return val = '完全匹配'
	   }else if(val == 'N'){ 
		   return val = '存在省市区不匹配'
	   }
   }
};

//    匹配结果
const isPass = val => {
	if(val=='' || val ==null){
	   return '-';
   }else{  
	   if(val == 'Y'){ 
		   return val = '合格'
	   }else if(val == 'N'){ 
		   return val = '不合格'
	   }
   }
};

// 分配状态
const isAllocated = val => {
	if(val=='' || val ==null){
	   return '-';
   }else{  
	   if(val == 'Y'){ 
		   return val = '已分配'
	   }else if(val == 'N'){ 
		   return val = '未分配'
	   }
   }
};

// 确认状态
const confirmState = val => {
	if(val=='' || val ==null){
	   return '-';
   }else{  
	   if(val == 'Y'){ 
		   return val = '已确认'
	   }else if(val == 'N'){ 
		   return val = '未确认'
	   }
   }
};

export {
  getDate,
  getTime,
  getVisible,
  getMenuType,
  getBizState,
  getstaffType,
  roleNames,
  numFmt,
  numDigit,
  approvalState,
  performancePayState,
  approvalStateTwo,
  insuranceStatus,
  natureType,
  province,
  city,
  district,
  region,
  contractState,
  payState,
  approvalStateCost,
  smallToBig,
  modelType,
  importState,
  getTimeDate,
  valueType,
  flowType,
  fileUrl,
  fileName,
  summaryResultValueType,
  filterImgUrl,
  meetingType,
  safeLevel,
  orgGradeType,
  orgRankType,
  orgType,
  getMonth,
  enterpriseCate,
  getDateSFM,
  customerType,
  upDigit,
  errorInfo,
  notifyPeriod,
  meetingBodyType,
  orgRank,
  orgGrade,
  maintainState,
  getRateType,
  getChargeState,
  getInvoiceType,
  getInvoiceCategory,
  getInvoiceCategoryList,
  getInvoiceOptions,
  getInvoiceState,
  getSupplierRate,
  getIsInvoiceFirst,
  getPaymentState,
  operateType,
  getTimeS,
  minTime,
  absoluteValue,
  importStateNew,
  tenantAccountState,
  commonFilterName,
  approveState,
  downState,
  quarterType,
  yearType,
  commonFilterNameList,
  sourceTypeFilter,
  accountTypeFilter,
  getSigningType,
  idType,
  contractContentTypeFilter,
  cleaningResult,
  matchingResult,
  isPass,
  isAllocated,
  confirmState
};
